import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalVarService {
  // 初始化一個 BehaviorSubject，並指定初始值

  private isInstalledApp = new BehaviorSubject<boolean>(true); //預設有安裝(因為只能從沒有安裝來判斷)
  private installSourceEvent = new BehaviorSubject<any>(null);

  // 是否已安裝了
  isInstalledApp$ = this.isInstalledApp.asObservable();

  // 安裝事件
  installSourceEvent$ = this.installSourceEvent.asObservable();

  /**
   * 設定是否有安裝app了
   * @param newValue 
   */
  setIsInstalledApp(newValue: boolean) {
    console.log(">>>>>>設定是否有安裝"+newValue);
    this.isInstalledApp.next(newValue);
  }


  /**
   * 設定安裝的event
   * @param event 
   */
  setInstallEvent(event: any) {
    this.installSourceEvent.next(event);
  }
}